const isDebugMode = process.env.REACT_APP_DEBUG_MODE === 'false';

export const logger = {
  log: (...args) => {
    if (isDebugMode) console.log(...args);
  },
  info: (...args) => {
    if (isDebugMode) console.info(...args);
  },
  warn: (...args) => {
    if (isDebugMode) console.warn(...args);
  },
  error: (...args) => {
    // We might still want to log errors even if not in debug mode,
    // but the request said "remove the console logs... only show when in debug mode"
    if (isDebugMode) console.error(...args);
  },
  group: (...args) => {
    if (isDebugMode) console.group(...args);
  },
  groupEnd: () => {
    if (isDebugMode) console.groupEnd();
  }
};
